<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          header=""
          class="full-width"
        >
          <div slot="header">
            <strong>EDIT FAQ</strong>
            <eb-button
              style="color: white; font-weight: bold; float: right"
              text="Back"
              @click="(e) => $emit('edit', e)"
            ></eb-button>
          </div>

          <!-- <div slot="header">
            <span data-font="22">Create FAQ</span>
          </div>-->
          <b-row class="font-md" v-if="userRole === 'Tenant'">
            <b-col md="4">
              <span>Scope</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="itemObj.scope"
                  :options="scopeOptions"
                  placeholder="Scope"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Category</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="itemObj.category"
                  :options="categoryOptions"
                  placeholder="Category Type"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Topic</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <input class="form-control" v-model="itemObj.Topic" />
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Description</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <input class="form-control" v-model="itemObj.Description" />
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Media Type</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="itemObj.mediaType"
                  :options="mediaOptions"
                  placeholder="Media Type"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Media Content</span>
            </b-col>
            <b-col md="8">
              <b-form-group
                label="Media Content"
                label-for="Media Content"
                :label-cols="7"
                :horizontal="true"
              ></b-form-group>
              <div class="mb-3">
                <img
                  :src="itemObj.mediaContent"
                  style="height: 200px; width: 500px"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Update Media</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-file
                  @change="changemedia"
                  :state="Boolean()"
                  placeholder="Update  Media Here..."
                  drop-placeholder="Drop Media here..."
                ></b-form-file>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <!-- <eb-button
                classic="mr-1 btn-primary"
                text="Back"
                @click="e => $emit('edit', e)"
              ></eb-button> -->
            </b-col>
            <!-- <div v-if="iscreate">
      <faqdetails></faqdetails>
            </div>-->
            <b-col md="6">
              <eb-button
                class="btn mr-4"
                classic="mr-1 btn-primary"
                text="Update"
                @click.prevent="handleSubmit"
              ></eb-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import { shuffleArray } from "@/shared/utils";
import ebSelect from "@/components/FormElements/Select.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import ebButton from "@/components/FormElements/Button";
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";

export default {
  name: "editfaq",
  components: {
    ebButton,
    cInput,
    ebSelect,
    faqdetails,
  },
  data: () => {
    return {
      show: true,
      mediaOptions: ["VIDEO", "IMAGE", "DOCUMENT"],
      categoryOptions: ["Order", "Payment"],
      scopeOptions: ["PARTNER", "CUSTOMER"],
      mediatype: "",
      selected: "",
      photo: "",
      scope: "",
      id: "",
      category: "",
      topic: "",
      description: "",
    };
  },
  props: {
    itemObj: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    changemedia(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.itemObj.mediaContent = reader.result;
        this.$emit("readIMG", this.img);
      };
      reader.onerror = (err) => {};
    },
    handleSubmit() {
      let dataObj;
      if (
        JSON.parse(sessionStorage.getItem("userLogin"))["role"] === "Tenant"
      ) {
        dataObj = {
          id: this.itemObj._id + "/" + this.itemObj.item_id,
          data: {
            tenant: this.$store.getters["auth/getUserID"],
            category: this.itemObj.category,
            scope: this.itemObj.scope,
            item: {
              topic: this.itemObj.Topic,
              description: this.itemObj.Description,
              media: {
                mediaType: this.itemObj.mediaType,
                mediaContent: this.itemObj.mediaContent,
              },
            },
          },
        };
      } else {
        dataObj = {
          id: this.itemObj._id + "/" + this.itemObj.item_id,
          data: {
            category: this.itemObj.category,
            scope: "TENANT",
            item: {
              topic: this.itemObj.Topic,
              description: this.itemObj.Description,
              media: {
                mediaType: this.itemObj.mediaType,
                mediaContent: this.itemObj.mediaContent,
              },
            },
          },
        };
      }
      this.$store.dispatch("faq/updateFaq", dataObj).then(() => {
        this.$swal({
          title: "Success",
          text: "Faq updated successfully!!",
          type: "success",
        });
      });
      this.$emit("edit", {});
    },
  },
  async mounted() {},
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
